import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_REGISTERED_VOTERS_CONFIG = createFcmDetails('registered_voters_config', {
	owner: 'Capybara',
	context: 'Controls conditions for displaying registered voters section',
	description:
		'We want to display a voters % if above minimum for petitions with a certain number of signatures. Temporally we will use a fixed percentage for a given set of petitions.',
	template: {
		minSignatures: 100,
		maxSignatures: 1000,
		minPercentage: 0.6,
		percentageForPetitions: [
			{
				petitionId: '123',
				percentage: 0.75,
			},
		],
	},
	import: false,
});
